import { node, dom } from 'jsx-pragmatic'
import { EVENT } from 'zoid/dist/zoid.frameworks'
import { destroyElement, EventEmitterType } from 'belter'

const CLASS = {
  VISIBLE: 'visible',
  INVISIBLE: 'invisible',
}

export default ({
  uid,
  props,
  frame,
  prerenderFrame,
  doc,
  event,
}: {
  uid: string
  props: unknown & { cspNonce: string; handleCloseModal: any }
  frame: HTMLElement
  prerenderFrame: HTMLElement
  doc: Document
  event: EventEmitterType
}): HTMLElement | undefined => {
  if (!frame || !prerenderFrame) {
    return
  }

  const { cspNonce } = props

  frame.setAttribute('allowfullscreen', '')

  prerenderFrame.classList.add(CLASS.VISIBLE)
  frame.classList.add(CLASS.INVISIBLE)

  const disableBodyScroll = () => {
    const body = document.querySelector('body') as HTMLElement
    body.style.overflow = 'hidden'
  }

  const enableBodyScroll = () => {
    const body = document.querySelector('body') as HTMLElement
    body.style.overflow = 'auto'
  }

  event.on(EVENT.RENDERED, () => {
    disableBodyScroll()
    prerenderFrame.classList.remove(CLASS.VISIBLE)
    prerenderFrame.classList.add(CLASS.INVISIBLE)

    frame.classList.remove(CLASS.INVISIBLE)
    frame.classList.add(CLASS.VISIBLE)

    setTimeout(() => {
      destroyElement(prerenderFrame)
    }, 1)
  })

  event.on(EVENT.CLOSE, () => {
    enableBodyScroll()
  })

  const closeModal = () => {
    props.handleCloseModal(frame, uid)
  }

  return node(
    'div',
    {
      id: uid,
      onClick: closeModal,
      class: 'ps-mbo-modal--backdrop',
    },
    node(
      'style',
      { nonce: cspNonce },
      `.ps-mbo-modal--backdrop {
        z-index: 9999;
        position: fixed;
        top: 0px;
        height: 100vh;
        width: 100%;
        background-color: rgb(0 0 0 / 0.4);
        --tw-backdrop-blur: blur(4px);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-left: 0px;
        padding-right: 0px;
        transition-property: opacity;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 100ms;
    }

    .ps-mbo-modal--dialog > iframe {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      transition: opacity .2s ease-in-out;
    }
    
    #${uid} iframe.${CLASS.INVISIBLE} {
        opacity: 0;
    }
    #${uid} iframe.${CLASS.VISIBLE} {
        opacity: 1;
    }
    .ps-mbo-modal--dialog {
      display: flex;
      position: relative;
      height: 100%;
      max-width: 100%;
      flex-direction: column;
      align-items: flex-start;
      overflow: auto;
      transition-property: all;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 100ms;
      border-radius: 0px;
      border-width: 0px;
      --tw-border-opacity: 1;
      border-color: #DDDDDD;
      --tw-bg-opacity: 1;
      background-color: #FFFFFF;
      --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
      filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
      width: 100%;
    }
    
    @media (min-width:640px) {
      .ps-mbo-modal--backdrop {
        padding-left: 1rem;
        padding-right: 1rem;
      }

      .ps-mbo-modal--dialog {
        height: 80%;
        max-width: 862px;
        border-width: 1px;
      }
    }
    `,
    ),
    node(
      'div',
      { class: 'ps-mbo-modal--dialog' },
      node('node', { el: frame, frameBorder: 0 }),
      node('node', {
        el: prerenderFrame,
        frameBorder: 0,
      }),
    ),
  ).render(dom({ doc }))
}
